// extracted by mini-css-extract-plugin
export var cardLayout = "_8z-1";
export var paginationContainer = "_8z-0";